import React, { useState } from 'react';
import { CommonModalProps } from '@wajeez-web/components/modals';
import { NumberInput } from '@wajeez-web/components/ui';
import { Modal } from '@wajeez-web/components/ui';

const AddQuantityBusinessModal: React.FC<CommonModalProps<number>> = ({
  onClose,
  isOpen,
  onSubmit,
}) => {
  const [quantity, setQuantity] = useState(0);

  return (
    <Modal
      title="Add Business Quantity"
      open={isOpen}
      onClose={onClose}
      onSubmit={() => {
        onSubmit && onSubmit(quantity);
      }}
    >
      <NumberInput
        label="Quantity"
        required={true}
        name="quantity"
        value={quantity}
        onChange={(name, val) => setQuantity(Number(val))}
      />
    </Modal>
  );
};

export default AddQuantityBusinessModal;
